import authHeaders from 'helpers/auth-header';
import request from './api';

function getTerminalsByBranch(vkn, branchId) {
  return request({
    url: `/terminal/identification-number/${vkn}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function addTerminal(vkn, body) {
  return request({
    url: `/terminal/identification-number/${vkn}`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}
function editTerminal(vkn, terminalId, body) {
  return request({
    url: `/terminal/identification-number/${vkn}/client-id/${terminalId}/clientStatus-id/${37}`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}

const branch = {
  getTerminalsByBranch,
  addTerminal,
  editTerminal,
};

export default branch;
